module.exports = __webpack_public_path__ + "img/lijifukuan.b9b3cbac.png";